import { useEffect, useState } from 'react';

/** Live prefers-reduced-motion flag. Lazy initializer reads matchMedia
 *  synchronously on first render so consumers' own useState initializers
 *  see the correct value on mount (see ResearchWelcomePanel history). */
export function usePrefersReducedMotion(): boolean {
    const [reduced, setReduced] = useState(
        () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    );
    useEffect(() => {
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, []);
    return reduced;
}
